module.exports = __webpack_public_path__ + "static/acupun_2_xl-5aef8dad05d9a369c9c721eca840f33f.png";